import { Box, Container, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Mono } from '../components/section';
import logo_white from '../assets/logo_white.png';
import { brand } from '../thema';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <Box component="footer" sx={{ backgroundColor: brand.dark, color: 'rgba(255, 255, 255, 0.7)', borderTop: `1px solid ${brand.lineDark}` }}>
            <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 }, py: 5, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'flex-start', md: 'center' }, justifyContent: 'space-between', gap: 3 }}>
                <img src={logo_white} alt="Reband Logo" width={100} height={30} />
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, fontSize: '0.8125rem' }}>
                    <Link href="/company" color="inherit" underline="hover">{t('company_info')}</Link>
                    <Link href="/message" color="inherit" underline="hover">{t('nav_message')}</Link>
                    <Link href="/policy" color="inherit" underline="hover">{t('Privacy policy')}</Link>
                    <Link href="/contact" color="inherit" underline="hover">{t('contact')}</Link>
                </Box>
                <Mono color="rgba(255, 255, 255, 0.5)">{t('home.footer.copyright')}</Mono>
            </Container>
        </Box>
    );
};

export default Footer;
